import { useRef, useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../contexts/globalContext';

import styles from './UserDetailsComponent.module.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

import DarkButtonComponent from './commons/DarkButtonComponent';

import userBoxWithoutQr from '../graphics/header/user-box-1.svg'
import userBoxWithQr from '../graphics/header/user-box-2.svg'
import userBoxGuest from '../graphics/user-box-2.svg'


const UserDetailsComponent = ({ setSeeUserDetails }) => {

    const { currentUser, setUserDetailsComponentTimer, setOpenEditProfile } = useContext(GlobalContext)

    const ref = useRef();

    const [qrPath, setQrPath] = useState()

    useEffect(() => {
        ref.current.focus();
        if (currentUser.telephone && currentUser.organization) {
            setQrPath(`/assets/cards/${currentUser._id}.png`)
        }
    }, []);

    function handleLogOut() {
        window.location.reload();
    }

    function getIcon(value) {
        switch (value) {
            case "ADMINISTRATOR":
                return "user-gear";
            case "MEMBER":
                return "user";
            case "VISITOR":
                return "adress-card";
            case "PARTNER":
                return "user-tie";
            default:
                return "id-card-clip";
        }
    }


    return (
        <div ref={ref} className={styles.component} tabIndex="0"
            onBlur={() => {
                setSeeUserDetails(false); 
                setUserDetailsComponentTimer(true)
            }}
        >
            <img
                src={currentUser.function ? (qrPath ? userBoxWithQr : userBoxWithoutQr) : userBoxGuest}
                className={currentUser.function ? styles.backgroundFunction : styles.backgroundWithout}
                alt="Background"
            />
            <div className={styles.title}>
                <div className={styles.iconBackground} style={{ borderColor: currentUser.role === 'ADMINISTRATOR' ? "#EA46FF" : "#28CCA0" }} />
                <div className={styles.iconCircle}>
                    <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas[getIcon(currentUser.role)]} />
                </div>
                <div className={styles.nameDetails}>
                    {currentUser.name}
                    <div className={styles.role} style={{ color: currentUser.role === 'ADMINISTRATOR' ? "#EA46FF" : "#28CCA0" }}>
                        {currentUser.role}
                    </div>
                </div>
            </div>
            {currentUser.function &&<div className={styles.details} style={{ padding: currentUser.function ? "" : 0, borderBottom: currentUser.function ? "" : "0px solid" }}>
                <div className={styles.function}>
                    {currentUser.function?.name}
                </div>
                {currentUser.department?.name}
            </div>}

            {qrPath && <img src={process.env.REACT_APP_CMS_URL + qrPath} className={styles.qrData} alt={"qrCode"} />}

            <DarkButtonComponent style={{
                position: "relative", marginTop: currentUser.function ? qrPath ? 28 : 4 : 20, marginLeft: 120, marginBottom: 23, height: 67,
                font: "normal normal 600 32px/70px Bio Sans"
            }} onClick={() => { }}>
                <FontAwesomeIcon className={styles.iconLogout} icon={byPrefixAndName.fas['qrcode']} />
                EDIT PROFILE
            </DarkButtonComponent>

            <div style={{ position: "absolute", left: 120, bottom: 125, height: 71, width: 575, cursor: "pointer" }}
                onClick={() => setOpenEditProfile(true)} />

            <DarkButtonComponent style={{
                position: "relative", marginTop: currentUser.function ? 4 : 10, marginLeft: 120, marginBottom: 23, height: 67,
                font: "normal normal 600 32px/70px Bio Sans"
            }} onClick={() => { }}>
                <FontAwesomeIcon className={styles.iconLogout} icon={byPrefixAndName.fas['arrow-right-from-bracket']} />
                SIGN OUT
            </DarkButtonComponent>

            <div style={{ position: "absolute", left: 120, bottom: 23, height: 71, width: 575, cursor: "pointer" }}
                onClick={() => handleLogOut()} />
        </div>


    );

}

export default UserDetailsComponent;